import React, { useState, useEffect } from "react";
import {
  CNavbar,
  CContainer,
  CNavbarBrand,
  CNavbarToggler,
  CCollapse,
  CNavbarNav,
  CNavItem,
  CNavLink,
  CDropdown,
  CDropdownToggle,
  CDropdownMenu,
  CDropdownItem,
} from "@coreui/react";
import { useNavigate } from "react-router-dom";
import Logo from "../../../assets/images/logo.png";
// This is commended because Peter advice us to link the social meedias OR delete them in 24S1, and the social medias has not ready yet
// I prefer to leavee the code here in case they are needed ini the future with the development of business.
// import InstagramIcon from "@mui/icons-material/Instagram";
// import FacebookIcon from "@mui/icons-material/Facebook";
// import LinkedInIcon from "@mui/icons-material/LinkedIn";
// import TwitterIcon from "@mui/icons-material/Twitter";
// import YouTubeIcon from "@mui/icons-material/YouTube";
import isLoggedIn from "../../../BackendAWS/isLoggedIn";
import Amplify, { Auth } from "aws-amplify";

const navLinks = [
  { label: "Home", path: "/" },
  { label: "Reserve", path: "/map-hotels" },
  { label: "About", path: "/about" },
  { label: "FAQs", path: "/faq" },
  { label: "Contact", path: "/Contact" },
  { label: "Terms", path: "/Terms" },
];

const TopNavbar = () => {
  const [activeLink, setActiveLink] = useState("/");
  const [isMobileNavOpen, setIsMobileNavOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [isUserLoggedIn, setIsUserLoggedIn] = useState(false);
  const [activeAuthLink, setActiveAuthLink] = useState("");

  const [hoveredLink, setHoveredLink] = useState('');

  const [showNav, setShowNav] = useState(false);

  useEffect(() => {
    if (isMobileNavOpen) {
      setShowNav(true);
    } else {
      const timeoutId = setTimeout(() => setShowNav(false), 500); // Delay for the animation to complete
      return () => clearTimeout(timeoutId);
    }
  }, [isMobileNavOpen]);

  const [navStyle, setNavStyle] = useState({
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "#DC6FB4",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    zIndex: 2000,
    padding: "35px 0",
    boxShadow: "-15px 0 15px -2px rgba(0, 0, 0, 0.5)",
    transition: "transform 0.2s ease-out, opacity 0.3s ease-out",
    transform: "translateY(70%)", // Start below visible area
    opacity: 0, // Start invisible
  });

  useEffect(() => {
    if (isMobileNavOpen) {
      // Start the opening animation
      setNavStyle(prevStyle => ({
        ...prevStyle,
        transform: "translateY(10%)", // Start from slightly below the top
        opacity: 0, // Start from fully transparent
        display: "flex", // Make sure it's visible
      }));

      // Trigger the transition to final visible state
      setTimeout(() => {
        setNavStyle(prevStyle => ({
          ...prevStyle,
          transform: "translateY(0)", // Move to fully visible
          opacity: 1, // Fully opaque
        }));
      }, 10); // Short delay to ensure the transition is triggered
    } else {
      // Start closing animation
      setNavStyle(prevStyle => ({
        ...prevStyle,
        transform: "translateY(10%)", // Move up slightly
        opacity: 0, // Fade out
      }));

      // Optionally, hide the nav completely after the animation
      setTimeout(() => {
        setNavStyle(prevStyle => ({
          ...prevStyle,
          display: "none", // Hide after animation
        }));
      }, 300); // Match the duration of the opacity transition
    }
  }, [isMobileNavOpen]);

  // Handle mouse enter and leave
  const handleMouseEnter = (link) => setHoveredLink(link);
  const handleMouseLeave = () => setHoveredLink('');

  const navigate = useNavigate();

  const handleLogOut = async () => {
    try {
      await Auth.signOut();
      setIsUserLoggedIn(false);
      navigate("/sign-in");
    } catch (error) {
      console.error("Error signing out: ", error);
    }
  };

  const authLinks = isUserLoggedIn
    ? [
        {
          label: "My Profile",
          path: "/myprofileAWS",
          styleName: "navLink",
        },
        { label: "Log Out", onClick: handleLogOut },
      ]
    : [
        { label: "Sign In", path: "/sign-in", styleName: "signInLink" },
        { label: "Sign Up", path: "/sign-up", styleName: "signUpLink" },
      ];

  /*
  const authDropdownLinks = [
    {
      label: "My Profile",
      path: "/myprofileAWS",
    },
    {
      label: "Log Out",
      onClick: handleLogOut,
    },
  ];
  */

  useEffect(() => {
    const checkUserLoggedInStatus = async () => {
      setIsUserLoggedIn(await isLoggedIn());
    };

    checkUserLoggedInStatus();

    const checkScroll = () => {
      if (window.scrollY > 30) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener("scroll", checkScroll);

    return () => {
      window.removeEventListener("scroll", checkScroll);
    };
  }, []);

  const handleNavLinkClick = (path, label) => {
    if (label !== "Log Out") {
      navigate(path);
    }

    if (label !== "Sign In" && label !== "Sign Up") {
      setActiveLink(path);
      if (label === "My Profile") {
        setActiveAuthLink(path);
      } else {
        setActiveAuthLink("");
      }
    } else {
      setActiveLink("");
    }
    setIsMobileNavOpen(false);
  };

  return (
    <>
      {/* <div style={styles.socialMediaBar}>
        <InstagramIcon style={styles.iconStyle} />
        <FacebookIcon style={styles.iconStyle} />
        <LinkedInIcon style={styles.iconStyle} />
        <TwitterIcon style={styles.iconStyle} />
        <YouTubeIcon style={styles.iconStyle} />
      </div> */}
      <CNavbar expand="lg" style={styles.navbarStyle}>
        <CContainer
          fluid
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          <div style={{ display: "flex", alignItems: "center" }}>
            <CNavbarBrand onClick={() => navigate("/")}>
              <div
                style={
                  // isScrolled
                  //   ? 
                    styles.logoContainer
        
                    // : styles.expandedLogoContainer
                }
              >
                <img
                  style={styles.roundedLogo}
                  src={Logo}
                  alt="ShowerAway Logo"
                />
              </div>
            </CNavbarBrand>
            <CNavbarNav className="d-none d-lg-flex">
              {navLinks.map((link, index) => (
                <CNavItem key={index}>
                  <CNavLink
                    style={
                      link.path === activeLink
                        ? { ...styles.navLink, ...styles.clickedNavLink }
                        : styles.navLink
                    }
                    onClick={() => handleNavLinkClick(link.path, link.label)}
                  >
                    {link.label}
                  </CNavLink>
                </CNavItem>
              ))}
            </CNavbarNav>
          </div>
          <div style={{ display: "flex", alignItems: "center" }}>
            <CNavbarToggler
              aria-label="Toggle navigation"
              onClick={() => {
                setIsMobileNavOpen(!isMobileNavOpen);
              }}
            />
            <CNavbarNav className="ml-auto d-none d-lg-flex">
              {authLinks.map((link, index) => (
                <CNavItem key={index}>
                  <CNavLink
                    style={
                      link.path === activeAuthLink
                      ? { ...styles.navLink, ...styles.clickedNavLink }
                      : { ...styles.navLink, ...styles[link.styleName], ...(hoveredLink === link.label && styles[`${link.styleName}Hover`]) }
                    }
                    onMouseEnter={() => handleMouseEnter(link.label)}
                    onMouseLeave={handleMouseLeave}
                    onClick={
                      link.onClick
                        ? link.onClick
                        : () => handleNavLinkClick(link.path, link.label)
                    }
                  >
                    {link.label}
                  </CNavLink>
                </CNavItem>
              ))}
            </CNavbarNav>
            {/*
            <CNavbarNav className="ml-auto d-none d-lg-flex">
              {!isUserLoggedIn && (
                <>
                  <CNavItem>
                    <CNavLink
                      style={{ ...styles.navLink, ...styles.signInLink }}
                      onClick={() => handleNavLinkClick("/sign-in")}
                    >
                      Sign In
                    </CNavLink>
                  </CNavItem>
                  <CNavItem>
                    <CNavLink
                      style={{ ...styles.navLink, ...styles.signUpLink }}
                      onClick={() => handleNavLinkClick("/sign-up")}
                    >
                      Sign Up
                    </CNavLink>
                  </CNavItem>
                </>
              )}
              {isUserLoggedIn && (
                <CDropdown variant="nav-item">
                  <CDropdownToggle
                    caret={false}
                    color="link"
                    className="my-account-dropdown"
                    style={styles.myAccountLink}
                  >
                    My Account
                  </CDropdownToggle>

                  <CDropdownMenu>
                    {authDropdownLinks.map((link, index) => (
                      <CDropdownItem
                        key={index}
                        onClick={
                          link.onClick
                            ? link.onClick
                            : () => handleNavLinkClick(link.path)
                        }
                      >
                        {link.label}
                      </CDropdownItem>
                    ))}
                  </CDropdownMenu>
                </CDropdown>
              )}
            </CNavbarNav> 
                      */}
          </div>

          {showNav && (
            <div style={navStyle}>
              <button
                style={styles.closeNavButton}
                onClick={() => setIsMobileNavOpen(false)}
              >
                x
              </button>
              <CNavbarNav className="w-100 p-3">
                {[...navLinks, ...authLinks].map((link, index) => (
                  <React.Fragment key={index}>
                    <CNavItem>
                      <CNavLink
                        style={
                          link.path === activeLink &&
                          link.label !== "Sign In" &&
                          link.label !== "Sign Up"
                            ? { ...styles.navLink, ...styles.clickedNavLink }
                            : link.label === "Sign In" ||
                              link.label === "Sign Up"
                            ? {
                                ...styles.navLink,
                                ...styles[link.styleName],
                                marginTop: "20px",
                              }
                            : link.styleName
                            ? { ...styles.navLink, ...styles[link.styleName] }
                            : styles.navLink
                        }
                        onClick={
                          link.onClick
                            ? link.onClick
                            : () => handleNavLinkClick(link.path)
                        }
                      >
                        {link.label}
                      </CNavLink>
                    </CNavItem>
                    {((!isUserLoggedIn &&
                      (link.label === "Home" ||
                        link.label === "Reserve" ||
                        link.label === "About" ||
                        link.label === "FAQs" ||
                        link.label === "Contact" ||
                        link.label === "Terms")) ||
                      (isUserLoggedIn &&
                        (link.label === "Home" ||
                          link.label === "Reserve" ||
                          link.label === "About" ||
                          link.label === "FAQs" ||
                          link.label === "Contact" ||
                          link.label === "Terms" ||
                          link.label === "My Profile"))) && (
                      <div style={styles.linkSeparator}></div>
                    )}
                  </React.Fragment>
                ))}
              </CNavbarNav>
            </div>
          )}
        </CContainer>
      </CNavbar>
    </>
  );
};

const styles = {
  navbarStyle: {
    backgroundColor: "#DC6FB4",
    position: "sticky",
    top: 0,
    width: "100%",
    zIndex: 1000,
  },
  logoContainer: {
    width: "60px",
    height: "60px",
    backgroundColor: "#ff9f00",
    borderRadius: "50%",
    overflow: "hidden",
  },
  expandedLogoContainer: {
    width: "100px",
    height: "100px",
    backgroundColor: "#ff9f00",
    borderRadius: "50%",
    overflow: "hidden",
    transition: "width 0.1s, height 0.1s",
  },
  roundedLogo: {
    display: "block",
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
  navLink: {
    color: "#ffffff",
    marginRight: "15px",
    border: "1px solid transparent",
    paddingLeft: "10px",
  },
  clickedNavLink: {
    color: "#FFCCFF",
  },
  signInLink: {
    color: "#db398f",
    backgroundColor: "#ffffff",
    padding: "5px 5px",
    borderRadius: "0px",
    marginLeft: "5px",
    marginRight: "5px",
    width: "90px",
    maxWidth: "90%",
    textAlign: "center",
  },
  signInLinkHover: {
    backgroundColor: '#e0e0e0', // 悬停时的背景色
  },
  signUpLink: {
    color: "#ffffff",
    backgroundColor: "#db398f",
    padding: "5px 5px",
    borderRadius: "0px",
    marginLeft: "5px",
    marginRight: "5px",
    width: "90px",
    maxWidth: "90%",
    textAlign: "center",
  },
  signUpLinkHover: {
    backgroundColor: '#c30d74', // 悬停时的背景色
  },
  closeNavButton: {
    position: "absolute",
    top: "10px",
    right: "10px",
    cursor: "pointer",
    fontSize: "30px",
    fontWeight: "75",
    color: "#ffffff",
    background: "#DC6FB4",
    borderRadius: "50%",
    width: "40px",
    height: "40px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    border: "none",
    outline: "none",
  },
  linkSeparator: {
    width: "100%",
    height: "1px",
    backgroundColor: "#ffffff",
    margin: "10px auto",
  },
  socialMediaBar: {
    backgroundColor: "#000",
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    padding: "5px 15px",
  },
  iconStyle: {
    color: "#ffffff",
    marginLeft: "10px",
  },
  // overlayBackground: {
  //   position: 'fixed',
  //   top: 0,
  //   left: 0,
  //   width: '100%',
  //   height: '100%',
  //   backgroundColor: 'rgba(0, 0, 0, 0.5)', // 黑色半透明
  //   zIndex: 300, // 此值需要在navbar zIndex之下但高于其他页面元素
  // },
  /*
  myAccountLink: {
    color: "#ffffff !important",
  },
  */
};

export default TopNavbar;
